import { motion } from "framer-motion";
import { BRAND, CONTACT } from "../../lib/landingData";
import { useLang } from "../../i18n/LanguageContext";
import { LogoMark } from "./LogoMark";

const ease = [0.22, 1, 0.36, 1];

export const AboutFirm = () => {
  const { t } = useLang();
  const a = t.brand.about;
  const facts = [
    { k: a.principal, v: BRAND.principal },
    { k: a.registration, v: BRAND.taxAgent },
    { k: a.office, v: CONTACT.address },
    { k: a.hours, v: CONTACT.hours },
  ];

  return (
    <section id="about" className="relative py-24 sm:py-32 bg-[var(--page)] border-t border-[var(--hairline)]" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease }}
          className="lg:col-span-5"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-terra font-semibold">{a.overline}</span>
          <h2 className="mt-5 font-display text-[var(--ink)] font-semibold tracking-tight leading-[1.05] text-3xl sm:text-4xl lg:text-5xl">
            {a.title}
          </h2>
          <div className="mt-8 flex items-center gap-3">
            <LogoMark className="h-12 w-auto shrink-0" testId="about-logo-mark" />
            <div className="leading-tight">
              <div className="font-display text-lg text-[var(--ink)]">{BRAND.name}</div>
              <div className="text-xs text-[var(--muted-ink)]">{BRAND.taxAgent}</div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <p className="text-base sm:text-lg leading-relaxed text-[var(--muted-ink)]" data-testid="about-p1">{a.p1}</p>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[var(--muted-ink)]" data-testid="about-p2">{a.p2}</p>
          <dl className="mt-10 grid sm:grid-cols-2 gap-x-10 gap-y-6">
            {facts.map((f, i) => (
              <div key={i} className="border-t border-[var(--hairline)] pt-4" data-testid={`about-fact-${i}`}>
                <dt className="text-[11px] uppercase tracking-[0.2em] text-[var(--muted-ink)] font-semibold">{f.k}</dt>
                <dd className="mt-1.5 text-sm sm:text-base text-[var(--ink)] leading-snug">{f.v}</dd>
              </div>
            ))}
          </dl>
        </motion.div>
      </div>
    </section>
  );
};
